import {Box, Typography} from '@mui/material';

export default function StepTitle({title, subtitle}: {title: string; subtitle: string}) {
  return (
    <Box>
      <Typography variant="h3" sx={{mb: 1, textAlign: 'center'}}>
        {title}
      </Typography>
      <Typography
        sx={{
          maxWidth: {
            xs: 'none',
            md: '60%'
          },
          mb: 2,
          mx: 'auto',
          textAlign: 'center'
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}
